// extracted by mini-css-extract-plugin
module.exports = {"contactItems":"ContactBlock_contactItems__Rkfw4","contactItem":"ContactBlock_contactItem__JAEvZ","contactImage":"ContactBlock_contactImage__I03R5"};